import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import BuildingTitle from '../../common/buildingTitle';
import CacheData from '../../common/utils/cacheData';
import { constants } from '../../common/constants/constants';
import CreditCardForm from './CreditCardForm';
import './CreditCard.scss';


export class CreditCard extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.make_payment');

        BllinkLogger.info(`CreditCard constructor `, props);
        let cartID = props.match.params.cartID;
        const createCartResponse = CacheData.fetchCache(`createCartResponse`, {cartID: cartID});

        BllinkLogger.info(`CreditCard createCartResponse for cart ${cartID}`, createCartResponse);
        this.state = {
            cartID: cartID,
            createCartResponse: createCartResponse,
        }

    }

    async componentDidMount() {
        // used to display the building address on the title
        this.afterLoadForCart(this.state, this.props);
    }

    render() {

        const {t} = this.props;
        this.setBodyClasses(constants.backgroundOptions.creditCard);
        const cartID = this.props.match.params.cartID;
        let renderPayButton = false;
        let hasCommission = false;
        let isOnePaymentCart = false;
        let currency = '';
        let amountForFirstPayment;
        let paymentTerminal;
        let blockedProviders = [] // american express

        BllinkLogger.info(`credit card state is `, this.state);

        // https://app.asana.com/0/1196545425570329/1200466807640426
        // to protect against duplicate charge
        let isCartSuccessful = (this.state.paymentDetails && this.state.paymentDetails.state === constants.APIContract.paymentStates.SUCCESS)
        if (isCartSuccessful){
            alert(t('payments.cart_has_been_payed_already'))
            window.location.href = `/status/${cartID}`
        }

        if (this.state.createCartResponse){
            BllinkLogger.info(`createCartResponse present`)
            amountForFirstPayment = this.state.createCartResponse.firstPaymentTotal;
            const maxInstallmentsInCart = this.state.createCartResponse.maxInstallmentsInCart;
            hasCommission = this.state.createCartResponse.hasTenantCommission;
            isOnePaymentCart = (maxInstallmentsInCart && maxInstallmentsInCart === 1);
            currency = this.state.createCartResponse.currency.toLowerCase();
            renderPayButton = true;
            paymentTerminal = this.state.createCartResponse.paymentTerminal;
            blockedProviders = paymentTerminal ? constants.APIContract.blockedProvider[paymentTerminal] : blockedProviders;
        }else{
            BllinkLogger.error(`no details for cart id ${this.props.match.params.cartID} on this client`)
        }


        return (
            <div className="container">

                <div className="p-dept-section col-md-12">
                    <BuildingTitle
                        address={this.state.address}
                        apartmentNumber={this.state.apartmentNumber}
                    />
                </div>

                <CreditCardForm
                    parentProps={this.props}
                    hasCommission={hasCommission}
                    amountForFirstPayment={amountForFirstPayment}
                    currency={currency}
                    renderPayButton={renderPayButton}
                    isOnePaymentCart={isOnePaymentCart}
                    paymentTerminal={paymentTerminal}
                    blockedProviders={blockedProviders}
                    cartID={cartID}
                    chargeDate={this.state.chargeDate}
                />
            </div>
        )
    }
}

export default withTranslation()(CreditCard);
